/**
 * Map an AI-generated ItineraryDraft to a CreateItineraryDto
 * for submission to the itinerary creation API.
 * @deprecated AI drafts should seed the normal itinerary form through
 * mapDraftToItinerarySeed so pricing, availability, and custom fields use the
 * same path as manual itinerary creation.
 */
export function mapDraftToCreateDto(draft) {
    return {
        customer_id: draft.customer_id ?? 0,
        booking_items: draft.booking_items.map((item) => ({
            service_id: item.service_id,
            start_datetime: item.start_datetime,
            end_datetime: item.end_datetime,
            quantity_of_participants: item.quantity_of_participants,
            custom_field_values: item.custom_field_values ?? {},
            ...(item.notes != null ? { notes: item.notes } : {}),
        })),
        tags: draft.tags,
    };
}
/**
 * Map an AI-generated ItineraryDraft to the same form seed shape used by the
 * normal itinerary creation flow. This intentionally does not produce an API
 * DTO; the itinerary form owns validation, pricing breakdowns, and persistence.
 */
export function mapDraftToItinerarySeed(draft) {
    const bookingItems = draft.booking_items.map((item) => ({
        service_id: item.service_id,
        service_name: item.service_name,
        service: {
            id: item.service_id,
            name: item.service_name,
        },
        start_datetime: item.start_datetime,
        end_datetime: item.end_datetime,
        quantity_of_participants: item.quantity_of_participants,
        custom_field_values: item.custom_field_values ?? {},
        ...(item.notes != null ? { notes: item.notes } : {}),
    }));
    return {
        customer_id: draft.customer_id ?? 0,
        customer_candidate: draft.customer_candidate ?? null,
        booking_items: bookingItems,
        slots_itineraries: bookingItems,
        tags: draft.tags
            .map((tag) => Number(tag))
            .filter((tag) => Number.isInteger(tag) && tag > 0),
        state: "PENDING",
    };
}
export const draftMappingService = {
    mapDraftToCreateDto,
    mapDraftToItinerarySeed,
};
